import { supabase } from './supabase.js';
import { parseLaunchPhaseConfig } from '../marketplace/utils/launchPhaseConfig.js';

let cached = null;
let cachedAt = 0;
const CACHE_MS = 45_000;

export const LAUNCH_PHASE_PAYMENTS_MSG =
  'Los pagos están desactivados en esta fase del lanzamiento. Podrás comprar cuando activemos la siguiente fase.';
export const LAUNCH_PHASE_AUCTIONS_MSG =
  'Las subastas están desactivadas en esta fase del lanzamiento. Podrás pujar cuando activemos la siguiente fase.';
export const LAUNCH_PHASE_PARTNER_OPS_MSG =
  'La operativa Partner estará disponible cuando activemos la fase con tiendas verificadas. Puedes solicitar alta como Partner.';

export function invalidateLaunchPhaseCache() {
  cached = null;
  cachedAt = 0;
}

/** Lee `app_config.launch_phase` (con caché breve). */
export async function fetchLaunchPhaseConfig() {
  if (cached && Date.now() - cachedAt < CACHE_MS) return cached;
  try {
    const { data, error } = await supabase
      .from('app_config')
      .select('value')
      .eq('key', 'launch_phase')
      .maybeSingle();
    if (error) throw error;
    cached = parseLaunchPhaseConfig(data?.value);
  } catch (_) {
    cached = parseLaunchPhaseConfig(null);
  }
  cachedAt = Date.now();
  return cached;
}

export async function isPaymentsEnabled() {
  const cfg = await fetchLaunchPhaseConfig();
  return !!cfg.flags.payments_enabled;
}

export async function isAuctionsEnabled() {
  const cfg = await fetchLaunchPhaseConfig();
  return !!cfg.flags.auctions_enabled;
}

export async function isPartnerOpsEnabled() {
  const cfg = await fetchLaunchPhaseConfig();
  return !!cfg.flags.partner_ops_enabled;
}

export async function assertPaymentsEnabled() {
  if (await isPaymentsEnabled()) return null;
  return LAUNCH_PHASE_PAYMENTS_MSG;
}

export async function assertAuctionsEnabled() {
  if (await isAuctionsEnabled()) return null;
  return LAUNCH_PHASE_AUCTIONS_MSG;
}
